import { DeckState, SET_SELECTED_DECK } from "./types";
import { DetailedLoadStatus } from "../../../../../../../common/utils/async-status";
import {
  createDeck,
  fetchDeck,
  fetchDecks,
  updateDeck,
  deleteDeck,
} from "./actions";
import { createFlashcard, deleteFlashcard } from "../flashcards/actions";

const initialState = {
  deckData: {},
  loadStatus: DetailedLoadStatus.WAITING,
  selected: "",
  error: null,
} as DeckState;

const DecksReducer = (state = initialState, action) => {
  switch (action.type) {
    case fetchDecks.fulfilled.type:
      return {
        ...state,
        deckData: action.payload.entities.decks,
        loadStatus: DetailedLoadStatus.OK,
        error: null,
      };
    case fetchDeck.pending.type:
      return {
        ...state,
        loadStatus: DetailedLoadStatus.FETCHING,
        error: null,
      };
    case fetchDecks.rejected.type:
    case fetchDeck.rejected.type:
    case createDeck.rejected.type:
    case updateDeck.rejected.type:
    case deleteDeck.rejected.type:
      return {
        ...state,
        loadStatus: DetailedLoadStatus.ERROR,
        error: action.payload,
      };
    case fetchDeck.fulfilled.type:
      return {
        ...state,
        deckData: Object.assign(
          {},
          state.deckData,
          action.payload.entities.decks
        ),
        error: null,
        loadStatus: DetailedLoadStatus.OK,
      };
    case createDeck.fulfilled.type:
      return {
        ...state,
        deckData: Object.assign(
          {},
          state.deckData,
          action.payload.entities.decks
        ),
        error: null,
        selected: action.payload.result,
      };
    case updateDeck.fulfilled.type:
      return {
        ...state,
        error: null,
        deckData: Object.assign(
          {},
          state.deckData,
          action.payload.entities.decks
        ),
      };
    case createFlashcard.fulfilled.type:
      const flashcardParentDeck = {
        ...state.deckData[action.meta.arg.deckUUID],
      };
      return {
        ...state,
        error: null,
        deckData: Object.assign({}, state.deckData, {
          [action.meta.arg.deckUUID]: {
            ...flashcardParentDeck,
            card_count: flashcardParentDeck.card_count + 1,
            cards: flashcardParentDeck.cards
              ? flashcardParentDeck.cards.concat(action.payload.result)
              : [action.payload.result],
          },
        }),
      };
    case deleteDeck.fulfilled.type:
      const deckDataCopy = { ...state.deckData };
      delete deckDataCopy[action.meta.arg];
      return {
        ...state,
        error: null,
        deckData: deckDataCopy,
      };
    case deleteFlashcard.fulfilled.type:
      const deleteFlashcardParentDeck = {
        ...state.deckData[action.meta.arg.deckUUID],
      };
      return {
        ...state,
        error: null,
        deckData: Object.assign({}, state.deckData, {
          [action.meta.arg.deckUUID]: {
            ...deleteFlashcardParentDeck,
            card_count: deleteFlashcardParentDeck.card_count - 1,
            cards: deleteFlashcardParentDeck.cards
              ? deleteFlashcardParentDeck.cards.filter(
                  (cId) => cId !== action.meta.arg.id
                )
              : [],
          },
        }),
      };
    case SET_SELECTED_DECK:
      return {
        ...state,
        error: null,
        selected: action.payload,
      };
    default: {
      return state;
    }
  }
};

export default DecksReducer;
